import { css } from 'styled-components';
import { CFBaseSearchbarHelpers, CFBaseSearchbarTokens } from './styles';
import { CFTokens } from '../../tokens';
export const CFBaseSearchbarStyles = {
    ClearButtonWrapper: css `
    margin-top: -${CFBaseSearchbarHelpers.clearButtonMarginTop}px;
    position: absolute;
    ${CFBaseSearchbarHelpers.clearButtonPosition}
  `,
    ClearButtonWrapperWeb: css `
    transition-property: opacity, transform;
    transition-duration: ${CFBaseSearchbarTokens.ROOT_TRANSITION_DURATION}ms;
    ${CFBaseSearchbarHelpers.decoratorAnimatedProperties};
  `,
    Input: css `
    padding: 0;
    flex: 1;
    background-color: transparent;
    border: 0;
    color: ${CFBaseSearchbarTokens.TEXT_COLOR.DEFAULT};
    font-size: ${CFBaseSearchbarHelpers.fontSize}px;
  `,
    InputWeb: css `
    caret-color: ${CFBaseSearchbarTokens.CARET_COLOR};
    ${CFBaseSearchbarHelpers.typeSpec};

    &:focus {
      outline-width: 0;
    }

    &::placeholder {
      color: ${CFBaseSearchbarTokens.TEXT_COLOR.PLACEHOLDER};
    }
  `,
    Root: css `
    ${CFBaseSearchbarHelpers.rootPadding};
    box-sizing: border-box;
    width: 100%;
    height: ${CFBaseSearchbarHelpers.rootHeight}px;
    display: flex;
    gap: ${CFBaseSearchbarTokens.ROOT_GAP}px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    position: relative;
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
    border-width: 2px;
    border-style: solid;
    border-color: ${CFBaseSearchbarHelpers.rootOutlineColor};
    background-color: ${CFBaseSearchbarHelpers.rootBackgroundColor};
  `,
    RootWeb: css `
    transition-property: padding, border, background-color;
    transition-duration: ${CFBaseSearchbarTokens.ROOT_TRANSITION_DURATION}ms;
  `,
    SearchIconWrapper: css `
    position: absolute;
    ${CFBaseSearchbarHelpers.searchIconPosition};
  `,
    SearchIconWrapperWeb: css `
    transition-property: opacity, transform;
    transition-duration: ${CFBaseSearchbarTokens.ROOT_TRANSITION_DURATION}ms;
    ${CFBaseSearchbarHelpers.decoratorAnimatedProperties};
  `,
};
